import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';
import * as React from 'react';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = 'md', ...props }, ref) => {
    const sizeClasses = {
      sm: 'h-4 w-4',
      md: 'h-8 w-8',
      lg: 'h-12 w-12',
    };

    return (
      <div ref={ref} className={cn('flex items-center justify-center', className)} {...props}>
        <Loader2 className={cn('animate-spin text-muted-foreground', sizeClasses[size])} />
      </div>
    );
  }
);
Spinner.displayName = 'Spinner';

export { Spinner };
